import React, { memo } from 'react';

export const DropSmall: React.FC = memo(() => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.85303 11.9199V7.73276C2.85303 7.58142 2.91315 7.43627 3.02017 7.32925C3.12719 7.22223 3.27233 7.16211 3.42368 7.16211H14.8367C14.9881 7.16211 15.1332 7.22223 15.2402 7.32925C15.3473 7.43627 15.4074 7.58142 15.4074 7.73276V11.9199C15.4074 17.9118 10.3214 19.8948 9.30853 20.23C9.19346 20.2726 9.06694 20.2726 8.95187 20.23C7.93896 19.8948 2.85303 17.9118 2.85303 11.9199Z"
      fill="#E0E1E2"
      stroke="#21282B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.25 8.92308C18.25 5.02885 13.75 2 13.75 2C13.75 2 9.25 5.02885 9.25 8.92308C9.25 10.0706 9.72411 11.1712 10.568 11.9827C11.4119 12.7941 12.5565 13.25 13.75 13.25C14.9435 13.25 16.0881 12.7941 16.932 11.9827C17.7759 11.1712 18.25 10.0706 18.25 8.92308Z"
      fill="white"
    />
    <path
      d="M14.2056 11.476C14.7556 11.3863 15.2631 11.1347 15.6581 10.7559C16.053 10.3771 16.316 9.88979 16.4106 9.36118"
      fill="white"
    />
    <path
      d="M14.1724 11.6303C14.7416 11.5338 15.2668 11.2631 15.6755 10.8554C16.0842 10.4477 16.3563 9.92317 16.4543 9.35424M18.3578 8.88273C18.3578 4.69149 13.7009 1.43164 13.7009 1.43164C13.7009 1.43164 9.04395 4.69149 9.04395 8.88273C9.04395 10.1178 9.53458 11.3023 10.4079 12.1757C11.2813 13.049 12.4658 13.5397 13.7009 13.5397C14.936 13.5397 16.1205 13.049 16.9938 12.1757C17.8672 11.3023 18.3578 10.1178 18.3578 8.88273Z"
      stroke="#21282B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
